import { ZOOM_MEETING_SUB_TYPES } from "../common/utils";
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import ZoneEduSchPlanComparison from '@/plans/ZONE_EDU_PLUS/dialog/full-comparison.vue'
import ZoomOneEduSchoolCampsDetailDialog from './plan-details-zoneduschcmp.vue';
import FullComparisonDialog from './full-comparison-dialog';
import PlanDetails from './plan-details.vue';
import { $config } from '@/global-install/index';

let planDetailsDialog = null, comparisonDialog = null;

function install(currentPlan) {
  const { category } = currentPlan;
  if($config('enableEduAnnualUpgrade') && (category === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP
    || category === ZOOM_MEETING_SUB_TYPES.EDUCATION)
  ) {
    planDetailsDialog = new ServiceConfirm(ZoomOneEduSchoolCampsDetailDialog);
    comparisonDialog = new ServiceConfirm(ZoneEduSchPlanComparison);
  } else {
    planDetailsDialog = new ServiceConfirm(PlanDetails);
    comparisonDialog = new ServiceConfirm(FullComparisonDialog);
  }
}


function showPlanDetail(props) {
  return planDetailsDialog?.confirm(props);
}

function showComparisonDialog(props) {
  return comparisonDialog?.confirm(props);
}

function destoryComparisonDialog() {
  if (comparisonDialog) {
    comparisonDialog.destroy()
  }

}

export default {
  install,
  showPlanDetail,
  showComparisonDialog,
  destoryComparisonDialog,
}
